import React from 'react';
import PropTypes from 'prop-types';
import { axisBottom } from 'd3-axis';
import { scaleTime } from 'd3-scale';
import { timeDay, timeHour } from 'd3-time';
import { timeFormat } from 'd3-time-format';
import 'd3-transition';

import { slowTransition } from '../utils/svgUtils';
import D3Component from './D3Component';
import './Dashboard.css';

function getDefaultDomain() {
  const today = timeDay(new Date());
  return [today, timeDay.offset(today, 1)];
}

function render(selection) {
  const {
    x,
    y,
    width,
    times = getDefaultDomain(),
    xTicks,
    tickFormat,
    ticks,
  } = selection.datum();
  const scale = scaleTime()
    .domain(times)
    .range([0, width]);
  const axis = axisBottom(scale)
    .ticks(ticks)
    .tickFormat(tickFormat)
    if(xTicks){
      axis.tickValues(xTicks)
    }

  selection.selectAll('g.x-axis').data([1])
  .join(
    enter => enter.append('g').attr('class', 'x-axis'),
    update => update.call(slowTransition),
  )
    .attr('transform', `translate(${x},${y})`)
    .call(axis);

  selection.selectAll('line')
    .attr('vector-effect', 'non-scaling-stroke');
  selection.selectAll('path')
    .attr('vector-effect', 'non-scaling-stroke');
}

function XAxis(props) {
  return (
    <D3Component graph={{ render }} {...props} />
  );
}

XAxis.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  times: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  tickFormat: PropTypes.func,
  ticks: PropTypes.oneOfType([PropTypes.number, PropTypes.array, PropTypes.func]),
};

XAxis.defaultProps = {
  x: 0.5,
  y: 0.5,
  width: 0,
  times: getDefaultDomain(),
  tickFormat: d => d.getHours() % 3 ? '' : timeFormat('%-I %p')(d),
  ticks: timeHour,
};

export default XAxis;
